module.exports = __webpack_public_path__ + "img/business-card.49ce5fa8.svg";